// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".all-films-carousel[data-v-0d75653d]  .content-container{padding-right:24px!important}.all-films-carousel[data-v-0d75653d]  .promo-content{align-items:center!important;padding-bottom:24px!important}.all-films-carousel[data-v-0d75653d]  .promo-slide{border-radius:8px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
